/**
 * @generated SignedSource<<dcce2f1c65b636e592fa3a5a328352b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roles"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "roles",
        "variableName": "roles"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "inviteMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InviteMemberMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InviteMemberMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4d77b8a4b1ad7771993ed28b4aafb447",
    "id": null,
    "metadata": {},
    "name": "InviteMemberMutation",
    "operationKind": "mutation",
    "text": "mutation InviteMemberMutation(\n  $email: String!\n  $roles: [NewUserRoleInput!]!\n) {\n  inviteMember(email: $email, roles: $roles) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "3d05564cdadf0c357b3ca67846aa37f6";

export default node;
